<template>
    <p v-if="!model.content && !isEditing">
        <i>No content.</i>
    </p>
    <RichTextEditor
        v-else
        class="text-editor"
        v-model="model"
        :readingMode="!isEditing"
    />
</template>
<script setup lang="ts">
import { Artefact } from "@/lib/artefacts";
import RichTextEditor from "@/components/RichTextEditor.vue";

const model = defineModel<Artefact>({ required: true });
defineProps<{
    isEditing: boolean;
}>();
</script>

<style lang="scss" scoped>
.text-editor :deep(c-text-editor) {
    &::part(menu-bar) {
        margin-left: calc(var(--default-gap) * -1);
        margin-right: calc(var(--default-gap) * -1);
    }

    &::part(node-heading-1),
    &::part(node-heading-2) {
        font-weight: normal;
        border-bottom: unset;
    }
}
</style>
